import Btn from './shared/Btn';

/**
 * @param {{ saveError: { detail?: string }|null, onRetry: () => void }} props
 */
export default function SaveErrorBanner({ saveError, onRetry }) {
  if (!saveError) return null;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12,
      padding: '10px 16px', margin: '12px 24px',
      background: 'var(--ab-denied-soft)',
      borderLeft: '3px solid var(--ab-denied)',
      borderRadius: 'var(--ab-radius-sm)',
    }}>
      <div style={{ flex: 1, fontSize: 13, color: 'var(--ab-denied)' }}>
        ✗ Save failed: {saveError.detail || 'Unknown error'}
      </div>
      <Btn kind="secondary" size="sm" onClick={onRetry}>Retry</Btn>
    </div>
  );
}
